const colors = {
  button: '#6600cc',
  lightButton: '#bf80ff',
  header: '#404040'
};

export default colors;
